import { render, staticRenderFns } from "./AccountantHome.vue?vue&type=template&id=2fc383a0"
import script from "./AccountantHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountantHome.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AccountantHome.vue?vue&type=style&index=0&id=2fc383a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports